import * as signalR from '@aspnet/signalr';
import { receivedCurrentWorkDayAgent } from '../scorecard/redux/performance_metrics_grid_data_actions';
import { receivedCurrentWorkDayMU } from '../scorecard/redux/performance_metrics_grid_data_actions';
import { receivedCurrentWorkDayTeam } from '../scorecard/redux/performance_metrics_grid_data_actions';

const signalRMiddleware = ({ dispatch, getState }) => next => async (action) => {
  
  let connect = false;
  let _username = null;
  let _isAgent = null;
  // register signalR after the user logged in
  if (action.type === "UPDATE_LOGIN_STATUS") {
    if(action && action.user) {
      _username = action.user.userName;
      _isAgent = action.user.position === 1 ? true : false;
      connect = true;
    }
  }
  else if (action.type === "SET_SIGNALR_CONNECTION") {
    let _state = getState();
    if(_state && _state.common && _state.common.user) {
        _username = _state.common.user.userName;
        _isAgent = _state.common.user.position === 1 ? true : false;
        connect = true;
    }
  }
  
  if(connect) {
    if(_username && !_isAgent) {
    
      let _scorecardApplicationName = process.env.REACT_APP_SCORECARD_APPLICATION_NAME;
      let _signalRHubWebAPI = process.env.REACT_APP_SIGNALR_HUB_API_URL;
      
      const connection = new signalR.HubConnectionBuilder()
        .withUrl(_signalRHubWebAPI + "?ApplicationName=" + _scorecardApplicationName + "&UserName=" + _username, { transport: signalR.HttpTransportType.WebSockets })
        .configureLogging(signalR.LogLevel.Information)
        .build();

      // event handlers, you can use these to dispatch actions to update your Redux store
      connection.on("ReceiveMessage", (data) => { 
        console.log("recevive message")
          let isUpsert = true;
          
          if(data && data.length > 0) {
              let groupingType = '0';
              groupingType = data[0].ScorecardMetricGrouping ? data[0].ScorecardMetricGrouping.toString() : "0";
              let itemObject = {}
              switch(groupingType) {
                  case '3':
                      //agent
                      let agentResult = [];
                      data.forEach(item => {
                          itemObject["name"] = item.Name;
                          itemObject["customerClosing"] = item.CustomerClosing;
                          itemObject["salesClosing"] = item.SalesClosing;
                          itemObject["unavailableRate"] = item.UnavailableRate;
                          itemObject["sales"] = item.Sales;
                          itemObject["deliveredCalls"] = item.DeliveredCalls;
                          itemObject["dateUpdated"] = item.DateUpdated;
                          itemObject["id"] = item.ID;
                      });
                      agentResult.push(itemObject);
                      dispatch(receivedCurrentWorkDayAgent(agentResult, isUpsert));
                      break;
                  case '2':
                      //team
                      let teamResult = [];
                      data.forEach(item => {
                          itemObject["name"] = item.Name;
                          itemObject["customerClosing"] = item.CustomerClosing;
                          itemObject["salesClosing"] = item.SalesClosing;
                          itemObject["unavailableRate"] = item.UnavailableRate;
                          itemObject["sales"] = item.Sales;
                          itemObject["deliveredCalls"] = item.DeliveredCalls;
                          itemObject["dateUpdated"] = item.DateUpdated;
                          itemObject["id"] = item.ID;
                      });
                      teamResult.push(itemObject);
                      dispatch(receivedCurrentWorkDayTeam(teamResult, isUpsert));
                      break;
                  case '1':
                      //mu
                      let muResult = [];
                      data.forEach(item => {
                          itemObject["name"] = item.Name;
                          itemObject["customerClosing"] = item.CustomerClosing;
                          itemObject["salesClosing"] = item.SalesClosing;
                          itemObject["unavailableRate"] = item.UnavailableRate;
                          itemObject["sales"] = item.Sales;
                          itemObject["deliveredCalls"] = item.DeliveredCalls;
                          itemObject["dateUpdated"] = item.DateUpdated;
                          itemObject["id"] = item.ID;
                      });
                      muResult.push(itemObject);
                      dispatch(receivedCurrentWorkDayMU(muResult, isUpsert));
                      break;
                  default:
                      break;
              }
          }
      });
      
      connection.onclose(async () => {
        await start();
      });

      async function start() {
          try {
              await connection.start();
              console.log("connection started")
              console.log(connection)    
          } catch (err) {
              console.log(err);
              setTimeout(() => start(), 5000);
          }
      };
      start();
    }
  }
  return next(action);
};
export default signalRMiddleware;


// WEBPACK FOOTER //
// ./src/features/common/signalRMiddleware.js